import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import "@reach/auto-id";
import "lodash/fp";
import "styled-components";
import { useDisplayMode } from "../../hooks/use-display-mode.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
import { AvatarWrapper, AvatarImageContainer, AvatarImage } from "./avatar.styles.es.js";
const propTypes = {
  alt: PropTypes.string,
  appearance: PropTypes.oneOf(["standard", "outlined"]),
  as: PropTypes.elementType,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  displayMode: PropTypes.oneOf(["light", "dark"]),
  image: PropTypes.string,
  interactive: PropTypes.bool,
  magnitude: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge"]),
  onClick: PropTypes.func,
  showPlaceholderIfEmpty: PropTypes.bool,
  variant: PropTypes.oneOf(["connection", "individual", "organisation"])
};
const defaultProps = {
  alt: void 0,
  appearance: "standard",
  as: void 0,
  children: void 0,
  disabled: false,
  displayMode: void 0,
  image: void 0,
  interactive: false,
  magnitude: "medium",
  onClick: void 0,
  showPlaceholderIfEmpty: false,
  variant: void 0
};
const Avatar = forwardRef(
  ({
    alt,
    as,
    appearance,
    children,
    disabled,
    displayMode: displayModeProp,
    image,
    interactive,
    magnitude,
    onClick,
    showPlaceholderIfEmpty,
    variant,
    ...restProps
  }, ref) => {
    const displayMode = useDisplayMode(displayModeProp);
    return /* @__PURE__ */ jsxs(
      AvatarWrapper,
      {
        ref,
        as,
        onClick: interactive && !disabled ? onClick : void 0,
        role: !as && interactive ? "button" : void 0,
        tabIndex: interactive ? 0 : void 0,
        $appearance: appearance,
        $disabled: disabled,
        $displayMode: displayMode,
        $interactive: interactive,
        $magnitude: magnitude,
        $showPlaceholderIfEmpty: showPlaceholderIfEmpty,
        $variant: variant,
        ...restProps,
        children: [
          children,
          image && /* @__PURE__ */ jsx(AvatarImageContainer, { children: /* @__PURE__ */ jsx(
            AvatarImage,
            {
              src: image,
              alt,
              $objectFit: variant === "organisation" ? "contain" : "cover"
            }
          ) })
        ]
      }
    );
  }
);
Avatar.propTypes = propTypes;
Avatar.defaultProps = defaultProps;
export {
  Avatar
};
